import moment, { Moment } from "moment";

import { TFunction } from "utils";

import { CROP_TYPE_FCPO, FieldPracticeResponse, PracticeSeeding, WithInjectedName } from "models";

import { GROUP_TYPE, PRACTICE_TYPE, SeedingItemData, TimelineCalendarItemsProps } from "pages/app/field-timeline/components/FieldDetailsTimeline.tsx";

const determinateSeedingPracticeEndDate = (startDate: string, endDate: string): Moment => {
  const months = moment(endDate).diff(moment(startDate), "months");

  if (months <= 5) return moment(endDate);

  return moment(startDate).add(5, "months");
};

export const createSeedingItems = (
  t: TFunction,
  fieldCropOverViewResponse: FieldPracticeResponse,
  seedingTypes: Array<WithInjectedName<PracticeSeeding>>,
  baselineYears: number[],
  isMandatory: boolean
) => {
  const seedingItems: TimelineCalendarItemsProps<SeedingItemData>[] = [];
  fieldCropOverViewResponse.crops.forEach((crop) => {
    if (!crop.seedingPracticeType || crop.cropType === CROP_TYPE_FCPO.UNDERSOWING) return;

    seedingItems.push({
      id: `${PRACTICE_TYPE.SEEDING}-${crop.id}`,
      group: crop.cropType === CROP_TYPE_FCPO.MAIN ? GROUP_TYPE.MAIN_CROP_SEEDING : GROUP_TYPE.SIDE_CROP_SEEDING,
      title: "",
      start_time: moment(crop.seedingStartDate),
      end_time: determinateSeedingPracticeEndDate(crop.seedingStartDate, crop.harvestEndDate), // We need end time in order to set the width of the item in the timeline
      practiceType: PRACTICE_TYPE.SEEDING,
      canResize: false,
      canMove: false,
      cropItemId: crop.id,
      data: {
        seedingValue: {
          seedingPracticeId: crop.seedingPracticeType,
          name: seedingTypes.find((seedingType) => seedingType.id === crop.seedingPracticeType)?.name ?? t("fieldTimeline:cropCard.unknown"),
          endDate: crop.seedingStartDate,
          isMandatory: isMandatory,
          isBaseline: baselineYears.includes(crop.year!),
          // TODO: should this be confirmed if the crop is confirmed? We aren't returning the seedings from the getFieldPractices endpoint
          isConfirmed: !!crop.isConfirmed,
        },
      },
    });
  });

  return seedingItems;
};
